const MarketClosed = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18" fill="none"><rect width="10" height="4" fill="currentColor" rx="2" x="4" y="7"></rect></svg>

    )
}
export default MarketClosed